import MaisDetalhes from './maisDetalhes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  setMaisDetalhesFieldAction,
  loadingMaisDetalhesAction,
  setErrorMaisDetalhesAction
} from '../../store/maisDetalhes/actions';

const makeValidProducts = ({ navegations }, { tipoPessoaValue, listTipoProduto }) => {
  let produtos = [];
  if (navegations && navegations.hasOwnProperty(tipoPessoaValue))
    produtos = navegations[tipoPessoaValue].Produtos;

  return listTipoProduto.filter(tipoProduto =>
    produtos.findIndex(p => p.Id === tipoProduto.IdProduto) > -1)
    .map(item => {
      return { value: item.IdProduto, name: item.IdProduto, label: item.Nome }
    });
}

const mapStateToProps = (state, nextState) => ({
  formMaisDetalhes: state.maisDetalhesReducer.formMaisDetalhes,
  tipoCadastro: state.tipoCadastroReducer,
  produtos: makeValidProducts(state.navegationStepsReducer, state.tipoCadastroReducer)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setMaisDetalhesFieldAction,
    loadingMaisDetalhesAction,
    setErrorMaisDetalhesAction
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaisDetalhes);